import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

interface ProxyOwner {
  UserId: number;
  Name: string;
  Email: string;
}

interface ProxyOwnerListState {
  isLoading: boolean;
  data: ProxyOwner[] | null;
  error: string | null;
}

const initialState: ProxyOwnerListState = {
  isLoading: true,
  data: [],
  error: null,
};

export const fetchProxyOwnerListData = createAsyncThunk(
  "CTDBProxyOwnerListSlice/fetchProxyOwnerListData",
  async (_, thunkApi) => {
    try {
      const response = await httpClient.get("/db/product/productOwnerProxy", {
        cache: false,
      });
      if (response.status != 200 || response.data.Status !== "success") {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to get commercial proxy owners list",
          });
        }
      }
      return response.data;
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: "Failed to get commercial proxy owners list",
      });
    }
  }
);

const CTDBProxyOwnerListSlice = createSlice({
  name: "CTDBProxyOwnerListSlice",
  initialState,
  reducers: {
    resetState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProxyOwnerListData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        fetchProxyOwnerListData.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status == "success") {
            state.isLoading = false;
            state.data = action.payload.Data;
            state.error = null;
          } else if (action.payload.Status == "error") {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        }
      )
      .addCase(
        fetchProxyOwnerListData.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message;
        }
      );
  },
});

export const { resetState } = CTDBProxyOwnerListSlice.actions;

export default CTDBProxyOwnerListSlice.reducer;
